import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from "@reduxjs/toolkit";
import { apiRequest } from "services/ServiceUtil";
import { LIBRARY_SERVICE_METHOD, RECOMMNDATION_SERVICE_METHOD } from "services/commonService";
import { SuggestedPlanState } from "./SuggestedPlans";

const SLICE = "SuggestedPlans";

const initialState: SuggestedPlanState = {
  listIds: [],
  totalRecords: 0,
  SuggestedPlansList: [],
  newAreaOfFocusesAvailable: false,
  removeInvalidPlan: {},
  loadingCount: 0,
  plansMetrics: [],
  selectedFocusAreas: []
};
export const fetchSuggestedPlansIdAsync = createAsyncThunk(
  `${SLICE}/fetchSuggestedPlansIdAsync`,
  (data: any, thunkApi) => {
    const payload = data.payload || {};
    const params = { innCode: data.innCode, externalHltId: data?.externalHltId || "" };
    return apiRequest(RECOMMNDATION_SERVICE_METHOD.putSuggestedPlans, payload, thunkApi, [], params);
  }
);

export const fetchSuggestedPlansAsync = createAsyncThunk(`${SLICE}/fetchSuggestedPlansAsync`, (data: any, thunkApi) => {
  const params = { externalHltId: data?.externalHltId || "" };
  return apiRequest(LIBRARY_SERVICE_METHOD.postPlans, data, thunkApi, [], params);
});

export const submitSuggestedPlansFeedbackAsync = createAsyncThunk(
  `${SLICE}/submitSuggestedPlansFeedbackAsync`,
  (data: {}, thunkApi) => apiRequest(RECOMMNDATION_SERVICE_METHOD.putFeedbacks, data, thunkApi)
);

const isSuggestedPlansThunk = (action: any) => action.type.startsWith(`${SLICE}/`);

export const SuggestedPlansSlice = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    reset: () => initialState,
    setSuggestedPlanList(state) {
      state.SuggestedPlansList = [];
    },
    resetSuggestedListIds(state) {
      state.listIds = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSuggestedPlansIdAsync.pending, (state) => {
        state.listIds = [];
      })
      .addCase(fetchSuggestedPlansIdAsync.fulfilled, (state, action: any) => {
        state.newAreaOfFocusesAvailable = action.payload.newAreaOfFocusesAvailable;
        state.selectedFocusAreas = action.payload.selectedFocusAreas;
        state.plansMetrics = [...action.payload.suggestedPlans];
        if (action.payload.suggestedPlans.length) {
          state.listIds = action.payload.suggestedPlans;
        }
      })
      .addCase(fetchSuggestedPlansIdAsync.rejected, (state, action) => {
        state.listIds = [];
        state.SuggestedPlansList = [];
      })
      .addCase(fetchSuggestedPlansAsync.fulfilled, (state, action: any) => {
        state.SuggestedPlansList =
          action.meta.arg.pagination.page === 1
            ? action.payload.plans
            : [...state.SuggestedPlansList, ...action.payload.plans];
        state.totalRecords = action.payload.meta?.page?.total;
      })
      .addCase(fetchSuggestedPlansAsync.rejected, (state) => {
        state.SuggestedPlansList = [];
      })
      .addCase(submitSuggestedPlansFeedbackAsync.fulfilled, (state, action: any) => {
        state.removeInvalidPlan = action.payload;
      })
      .addMatcher(
        isPending(fetchSuggestedPlansIdAsync, fetchSuggestedPlansAsync, submitSuggestedPlansFeedbackAsync),
        (state) => {
          state.loadingCount += 1;
        }
      )
      .addMatcher(
        (action) => (isFulfilled(action) || isRejected(action)) && isSuggestedPlansThunk(action),
        (state) => {
          state.loadingCount -= 1;
        }
      );
  }
});

export const { setSuggestedPlanList, resetSuggestedListIds, reset } = SuggestedPlansSlice.actions;

export default SuggestedPlansSlice.reducer;
